<div class="card">
  <div class="container2">
    <button
      mat-mini-fab
      aria-label="Example icon button with a home icon"
      onclick="window.history.go(-1); return false;"
      style="background: white"
    >
      <!-- routerLink="../home" -->
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="container mb-5">
      <div class="row">
        <div class="col-12 mb-3">
          <div class="d-flex justify-content-center h-100">
            <div class="searchbar" *ngIf="casos.length > 0">
              <input
                class="search_input"
                type="text"
                [(ngModel)]="search"
                placeholder="Filtrar..."
              />
              <button class="search_icon" (click)="filter()">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="content-table text-center"
        style="overflow: initial !important"
      >
        <table
          mat-table
          #dataTable
          [dataSource]="dataSource"
          matSort
          style="--min-width: 100%"
          class="table-striped text-center"
          *ngIf="casos.length > 0"
        >
          <ng-container matColumnDef="caso">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Caso
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.numero_caso }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fecha_solicitud">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Fecha de Solicitud
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.updatedAt | date : "dd/MM/yyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="comentario">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Comentario
            </th>
            <td mat-cell *matCellDef="let element">
              {{
                element.comentRevision
                  ? element.comentRevision.substring(0, 31)
                  : "Sin comentario"
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="opciones">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            ></th>
            <td mat-cell *matCellDef="let element" style="text-align: right">
              <button
                class="button2"
                [routerLink]="'../detalle/' + element._id"
              >
                Ir al caso
              </button>
              <button class="button3" (click)="aprobar(element)">
                Aprobar
              </button>
              <button class="button4" (click)="noAprobar(element)">
                No Aprobar
              </button>
            </td>
          </ng-container>

          <tr mat-header-row></tr>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        *ngIf="casos.length > 0"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [pageSize]="5"
        [showFirstLastButtons]
      ></mat-paginator>

      <div *ngIf="casos.length < 1" class="text-center nodata">
        No se encontraron casos para aprobar
      </div>
    </div>
  </div>
</div>
